export default "Électrolyse, métallurgie, électro-intensité : votre site industriel peut relever de taux réduits d'accise sur l'électricité (ex-CSPE). Cartographie des usages et réclamation du trop-versé.";
